<template>
  <b-modal
    :visible="show"
    title="Detalhe da execução"
    size="xl"
    centered
    hide-footer
    @hidden="$emit('close')"
  >
    <div v-if="execucao">
      <div class="d-flex justify-content-between align-items-start mb-5">
        <div>
          <h5 class="font-weight-bolder mb-2">
            Competência {{ execucao.competencia }}
          </h5>
          <div class="text-muted">
            {{ formatPeriodo(execucao.data_inicial, execucao.data_final) }}
          </div>
        </div>
        <StatusBadge :status="execucao.status" />
      </div>

      <b-row class="mb-5">
        <b-col md="3">
          <strong>Tipo de execução</strong>
          <p>{{ labelTipoExecucao(execucao.tipo_execucao) }}</p>
        </b-col>
        <b-col md="3">
          <strong>Início</strong>
          <p>{{ formatDateTime(execucao.iniciado_em) }}</p>
        </b-col>
        <b-col md="3">
          <strong>Fim</strong>
          <p>{{ formatDateTime(execucao.finalizado_em) }}</p>
        </b-col>
        <b-col md="3">
          <strong>Tamanho do pacote</strong>
          <p>{{ formatBytes(execucao.zip_size) }}</p>
        </b-col>
      </b-row>

      <b-alert v-if="execucao.erro" show variant="warning">
        {{ execucao.erro }}
      </b-alert>

      <div class="d-flex justify-content-end mb-4">
        <button
          type="button"
          class="btn btn-light-primary mr-2"
          :disabled="!temPacote"
          @click="$emit('download', execucao)"
        >
          <i class="fa fa-download mr-1"></i>
          Baixar pacote
        </button>
        <button
          type="button"
          class="btn btn-light"
          :disabled="!temPacote"
          @click="$emit('resend', execucao)"
        >
          <i class="fa fa-envelope mr-1"></i>
          Reenviar e-mail
        </button>
      </div>

      <h6 class="font-weight-bolder">Arquivos gerados</h6>
      <div class="table-responsive mb-5">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Arquivo</th>
              <th>Status</th>
              <th>Erro</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="arquivo in arquivos" :key="arquivo.id">
              <td>{{ arquivo.tipo }}</td>
              <td>{{ arquivo.nome_arquivo || "-" }}</td>
              <td>{{ labelStatusArquivo(arquivo.status) }}</td>
              <td>{{ arquivo.erro || "-" }}</td>
            </tr>
            <tr v-if="arquivos.length === 0">
              <td colspan="4" class="text-muted text-center">
                Nenhum arquivo registrado.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h6 class="font-weight-bolder">Logs de e-mail</h6>
      <div class="table-responsive">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>E-mail</th>
              <th>Tipo</th>
              <th>Status</th>
              <th>Enviado em</th>
              <th>Erro</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="log in emailLogs" :key="log.id">
              <td>{{ log.email }}</td>
              <td>{{ labelTipoEmail(log.tipo) }}</td>
              <td>{{ labelStatusEmailLog(log.status) }}</td>
              <td>{{ formatDateTime(log.sent_at) }}</td>
              <td>{{ log.erro || "-" }}</td>
            </tr>
            <tr v-if="emailLogs.length === 0">
              <td colspan="5" class="text-muted text-center">
                Nenhum log de e-mail registrado.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </b-modal>
</template>

<script>
import StatusBadge from "./StatusBadge.vue";
import {
  formatBytes,
  formatDateTime,
  formatPeriodo,
  labelStatusArquivo,
  labelStatusEmailLog,
  labelTipoExecucao,
} from "@/modules/envio-contabilidade/utils";

export default {
  name: "EnvioContabilidadeExecucaoDetalheModal",
  components: {
    StatusBadge,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    execucao: {
      type: Object,
      default: null,
    },
  },
  computed: {
    arquivos() {
      return this.execucao && Array.isArray(this.execucao.arquivos)
        ? this.execucao.arquivos
        : [];
    },
    emailLogs() {
      return this.execucao && Array.isArray(this.execucao.email_logs)
        ? this.execucao.email_logs
        : [];
    },
    temPacote() {
      return Boolean(this.execucao && (this.execucao.zip_url || this.execucao.zip_path));
    },
  },
  methods: {
    formatBytes,
    formatDateTime,
    formatPeriodo,
    labelStatusArquivo,
    labelStatusEmailLog,
    labelTipoExecucao,
    labelTipoEmail(tipo) {
      const labels = {
        to: "Destinatários",
        cc: "Cópia",
        bcc: "Cópia oculta",
      };

      return labels[tipo] || tipo || "-";
    },
  },
};
</script>
